import type { StatusCategory } from '@atlassian/jira-common-constants/src/status-categories.tsx';
import type { WorkflowDocumentScope } from '../../model/types.tsx';

export const INITIAL = 'INITIAL' as const;
export const GLOBAL = 'GLOBAL' as const;
export const DIRECTED = 'DIRECTED' as const;

type ApiTransitionType = typeof INITIAL | typeof GLOBAL | typeof DIRECTED;

type StatusReference = string | null;

type Point = { x: number; y: number };

export type ApiWorkflowStatus = {
	statusReference: StatusReference;
	layout?: Point;
	deprecated?: boolean;
	properties?: {
		[key: string]: string;
	};
	approvalConfiguration?: {
		active: boolean;
		transitionApproved: string;
		transitionRejected: string;
	};
};

export type ApiReadViewRule = {
	id: string;
	ruleKey: string;
	parameters?: {
		[key: string]: string;
	};
};

export type ApiConditionGroup = {
	operation: 'ANY' | 'ALL';
	conditions: ApiReadViewRule[];
	conditionGroups: ApiConditionGroup[];
};

type ApiProperties = {
	[key: string]: string;
};

type ApiTransitionLink = {
	fromStatusReference?: StatusReference;
	fromPort?: number | null;
	toPort?: number | null;
};

export type ApiReadViewTransition = {
	id: string;
	type: ApiTransitionType;
	toStatusReference: StatusReference;
	links: ApiTransitionLink[];
	to?: { statusReference: StatusReference };
	name: string;
	description: string;
	actions?: ApiReadViewRule[];
	validators?: ApiReadViewRule[];
	triggers?: ApiReadViewRule[];
	conditions?: ApiConditionGroup;
	transitionScreen?: ApiReadViewRule;
	properties?: ApiProperties;
};

type Version = {
	id: string;
	versionNumber: number;
};

export type ApiReadViewWorkflow = {
	scope: WorkflowDocumentScope;
	version: Version;
	id: string;
	name: string;
	description: string;
	startPointLayout: Point;
	loopedTransitionContainerLayout?: Point;
	statuses: ApiWorkflowStatus[];
	transitions: ApiReadViewTransition[];
};

export type ApiReadViewStatus = {
	id: string;
	statusReference: string;
	name: string;
	rawName: string;
	statusCategory: StatusCategory;
	scope: WorkflowDocumentScope;
	description: string;
};

// Spec: https://hello.atlassian.net/wiki/spaces/HELIX/pages/3996661433/Design+-+Read+only+Workflow+API
export type ApiReadViewWorkflowResponse = {
	statuses: ApiReadViewStatus[];
	workflows: ApiReadViewWorkflow[];
};

export type ReadViewWorkflowIdentifier = {
	workflowId?: string;
	workflowIds?: string[];
	workflowName?: string;
	issueTypeId?: string;
	projectId: string;
};
